// extracted by mini-css-extract-plugin
export var actionText = "_r7-4";
export var container = "_r7-0";
export var leftSection = "_r7-1";
export var rightSection = "_r7-2";
export var settingsButton = "_r7-6";
export var settingsIcon = "_r7-7";
export var shortcut = "_r7-5";
export var shortcutGroup = "_r7-3";